/** Customize as a Streamlined solve sends it: the 11-player body without the
    included players, which a points solve does not take. */
export const toStreamlineSolveSettings = (f) => ({
    untradeable: f.useUntradeablesOnly,
    excludeActiveSquad: f.excludeActiveSquad,
    excludeObjectivePlayers: f.excludeObjectivePlayers,
    excludeSbcPlayers: f.excludeSbcPlayers,
    includeTransferList: f.includeTransferlist,
    prioritizeDuplicates: f.prioritizeDuplicates,
    prioritizeSbcStorage: f.prioritizeSbcStorage,
    excludedPlayers: f.excludedPlayers.flatMap((p) => (p ? p.resourceId : [])),
    minRating: f.minRating,
    maxRating: f.maxRating,
});
//# sourceMappingURL=settings.js.map